<template>
  <section>
    <div class="modal fade" id="CascoRisksModal" tabindex="-1" aria-labelledby="CascoRisksModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header p-5">
            <h5 class="modal-title" id="CascoRisksModalLabel">Страховые риски</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body p-5">
            <div class="fs-6 fw-bold mb-3">Страховые риски</div>
            <div class="text-gray-600 fs-5">
              <p v-if="product !== 'DSAT_CASCO_SE2'">- дорожно-транспортное происшествие (ДТП): событие, возникшее в процессе движения по дороге автомобильного транспорта и с его участием, при котором произошло столкновение с другим автомобильным транспортом, наезд (удар) на движущиеся или неподвижные предметы (сооружения, препятствия, птиц, животных и т.п.), опрокидывание, затопление, а также падение какого-либо предмета на него; </p>
              <p>- противоправные действия третьих лиц: угон, разбой, грабеж, кража автомобильного транспорта, и уничтожение либо повреждение их, связанное с угоном, разбоем, грабежом, кражей либо попыткой угона, разбоя, грабежа, кражи автомобильного транспорта; </p>
              <p>- стихийные бедствия: буря, шторм, ураган, град, удар молнии, землетрясение, горный обвал, оползень; </p>
              <p>- иные непредвиденные события: пожар, взрыв, провал под лед, повреждение водопроводной, отопительной или канализационной систем.</p>
            </div>
            <div class="fs-6 fw-bold mb-3">Франшиза</div>
            <div class="text-gray-600 fs-5">
              <p>- Безусловная франшиза при повреждении застрахованного транспортного средства в результате любого страхового случая составляет {{ franchise }} % от страховой суммы единицы соответствующего транспортного средства;</p>
              <p>- Несмотря на п.п.1) настоящего пункта безусловная франшиза при угоне, или грабеже, или разбое, или краже, или попыткой угона, или грабежа, или разбоя, или кражи застрахованного транспортного средства составляет 10 % от страховой суммы единицы соответствующего Транспортного Средства.</p>
              <p>- Несмотря на п.п.1) и п.п.2) настоящего пункта безусловная франшиза при полной гибели или утрате в результате любого страхового случая застрахованного транспортного средства составляет 10 % от страховой суммы единицы соответствующего Транспортного Средства.</p>
            </div>
          </div>
          <div class="modal-footer p-3 justify-content-center">
            <button
                type="button"
                class="btn btn-sm btn-secondary"
                data-bs-dismiss="modal"
            >Закрыть</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CascoRisksModal',
  props: {
    franchise: null,
    product:   null,
  }
}
</script>

<style scoped>

</style>